import styled from "styled-components";

export const ErrorMessageStyled = styled.div`
  color: red;
  font-size: 15px;
  display: block;
`;
